import PopupQueueComponent from '@/components/popupQueue';
import { CardProductAdvertiseLinkType, CardProductAdvertiseType } from '@/constants';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import { NoticeBar } from 'react-vant';
import {
  apiCardEmSecondAuth,
  apiGeEmInfo,
  apiGetCardHomeCarousel,
  apiGetCardLibraryCustomer,
  apiGetCardPackDetail,
  apiGetDianxinTagToRealName,
  apiGetFirstActivityList,
  apiGetHomtTopAdv,
  apiGetMainlyPromoteGoods,
  apiGetProductAdvertiseList,
  apiGetRealCount,
  apiGetSysDeptUrl,
  apiGettGoodsList,
  apiInspect,
  apiIsActive,
  apiGettKfInfo,
  apiGetClientEntrySortByDept,
  apiGetClientEntrySortByPack,
} from '../../api';
import Button from '../../components/button';
import Page from '../../components/page';
import main, { AppLocalKey } from '../../main';
import { RealPackPriorityStatus, RechargeType } from '../../utils/dict';
import {
  copyToClipboard,
  flowKTOG,
  formatNumber,
  LoadingMask,
  showBottom,
  showConfirm,
  showToast,
} from '../../utils/utils';
import FavoriteDialog from './favoriteDialog';
import FirstActiveFloat from './firstActiveFloat';
import RecommendAdvDialog from './recommendAdvDialog';
import WifiInfo from './wifiInfo';
export class GoodsTagIcon {
  /// 热卖
  static hot = 'hot';

  /// 秒杀
  static secondsKill = 'seconds_kill';

  /// 火爆
  static fieryFire = 'fiery_fire';

  /// 推荐
  static push = 'push';
  static getTagIcon(tag: string): string {
    const icons = {
      [GoodsTagIcon.hot]: '/pic/icon_tag_sale.png',
      [GoodsTagIcon.secondsKill]: '/pic/icon_tag_second_kill.png',
      [GoodsTagIcon.fieryFire]: '/pic/icon_tag_hot.png',
      [GoodsTagIcon.push]: '/pic/icon_tag_push.png',
    };
    return icons[tag] ?? '';
  }
}
export default function HomePage() {
  // 定义 ceanImg 类型
  type ceanImg = {
    imgUrl: string;
    type: string;
    skipUrl: string;
  };
  const navigate = useNavigate();
  const [currentEm, setCurrentEm] = useState<CurrentEm | undefined>(main.currentEm);
  // 二次认证数据
  const [cardEmSecondAuth, setCardEmSecondAuth] = useState<CardEmSecondAuth | undefined>();
  const [realCount, setRealCount] = useState<{
    realNameY?: number;
    realNameN?: number;
    all?: boolean;
    description?: string;
  }>({});
  // const [packOrderCount, setPackOrderCount] = useState(0);
  // const [payOrderCount, setPayOrderCount] = useState(0);
  // const [incomeCount, setIncomeCount] = useState(0);
  // const [couponCount, setCouponCount] = useState(0);
  const [oceanList, setoceanList] = useState<{ left: ceanImg[]; right: ceanImg[] }>({
    left: [],
    right: [],
  });
  // 商城配置

  const [shopConfiguration, setShopConfiguration] = useState<any>();

  // 是否有首充活动 有的话就悬浮按钮 并判断是否直接跳转进去
  const [hasChargeFirstActive, setHasChargeFirstActive] = useState(false);
  // 是否强制活动
  const [forceActivity, setForceActivity] = useState(false);
  // 是否自动跳转活动页面
  const [showActivity, setShowActivity] = useState(false);
  // 所有接口加载完，一般是在设备详情加载完之后，再加载各种统计和活动，最后一个接口设置加载完成
  const [loaded, setLoaded] = useState(false);
  //卡库中的客服电话
  const [serverPhone, setServerPhone] = useState('');
  /** 显示首页广告 */
  const [showRecommendAdvDialog, setShowRecommendAdvDialog] = useState<any>();
  // 首页按钮文案
  const [realPackPriorityType, setRealPackPriorityType] = useState<string>(RealPackPriorityStatus.pack);
  // 首页广告-新版
  const [productAdvertiseList, setProductAdvertiseList] = useState<CardProductAdvertise[]>();
  /** 打了电信实名标签的需要弹窗提示实名 */
  const [dianxinTagWillShow, setDianxinTagWillShow] = useState({ need: false, show: false, realUrl: '', iccid: '' });
  // 自定义客服地址
  const [kfInfo, setKfInfo] = useState<any>();
  // 顶部广告
  const [homeTopAdv, setHomeTopAdv] = useState<{ topImg?: string; topImgUrl?: string; topImgStatus?: string }>({
    topImg: '',
    topImgUrl: '',
    topImgStatus: '',
  });
  // 后端动态按钮配置
  const [entrySortList, setEntrySortList] = useState<{ sort: number; key: string; label: string }[] | null>(null);
  // 按钮排序是否已加载完成
  const [entrySortLoaded, setEntrySortLoaded] = useState(false);
  useEffect(() => {
    loadCurrentEM();
    getShopData(main?.homeShopId);
  }, []); // eslint-disable-line

  async function getOceanList(emId: string) {
    try {
      let res = await apiGetCardHomeCarousel(emId);
      let data = res.data || [];
      if (res.status === 200) {
        let list = {
          left: [],
          right: [],
        };
        list.left = data
          .filter((item: any) => {
            return item.position === 'left';
          })
          .sort((a: any, b: any) => {
            return a.priority - b.priority;
          })
          .map((item: any) => {
            return {
              imgUrl: item.imgUrl,
              type: item.type,
              skipUrl: item.skipUrl,
            };
          });
        list.right = data
          .filter((item: any) => {
            return item.position === 'right';
          })
          .sort((a: any, b: any) => {
            return a.priority - b.priority;
          })
          .map((item: any) => {
            return {
              imgUrl: item.imgUrl,
              type: item.type,
              skipUrl: item.skipUrl,
            };
          });
        setoceanList(list);
      }
    } catch (e: any) { }
  }
  useEffect(() => {
    if (loaded) {
      handleCheckPageStatus();
    }
  }, [loaded]); // eslint-disable-line

  async function handleCheckPageStatus() {
    // 优先验证绑卡，如果链接内带卡号 直接去绑卡
    if (!!main.nextBindEm) {
      navigate('/add-em');
      return;
    }
    // 是否自动跳到了别的页面，是的话不检测收藏弹窗，没有跳的时候才检测
    let toSomePage = false;
    let realPackType = await getRealPackPriorityStatus(main?.currentEm);
    if (hasChargeFirstActive && !main.toActivity[currentEm?.id!]) {
      if (!forceActivity) {
        main.toActivity[currentEm?.id!] = true;
      }
      toSomePage = true;
      if (showActivity) {
        navigate('/activity');
      }
    } else if (dianxinTagWillShow.need && !dianxinTagWillShow.show) {
      //  实名电信 标签 弹窗
      let res = await showConfirm({
        title: '温馨提示',
        maskClose: true,
        content:
          '接运营商通知，移动网络近期维护不能使用，为了避免您的网络中断，请实名电信继续使用！感谢您的支持和理解！',
        hideCancelBtn: true,
        confirmBtnText: '去实名',
      });
      setDianxinTagWillShow((v) => Object.assign({}, v, { show: true }));
      if (!res) return;
      // copyToClipboard(dianxinTagWillShow.iccid);
      // showToast('卡号已复制到剪贴板');
      // await delay(1500);
      showToast('正在跳转...');
      toSomePage = true;
      window.location.href = dianxinTagWillShow.realUrl;
    } else if (!!realPackType) {
      if (realPackType === 'real') {
        toSomePage = await checkRealName();
      } else {
        toSomePage = await checkPackage();
      }
    }

    // 如果不需要跳页面 又没有弹出过收藏弹窗
    if (!toSomePage) {
      let isOpenDialog = localStorage.getItem(AppLocalKey.showFavoriteDialog);
      if (isOpenDialog !== 'true') {
        localStorage.setItem(AppLocalKey.showFavoriteDialog, 'true');
        await showBottom((onOk) => <FavoriteDialog onOk={onOk} />);
      }
    }
  }
  async function checkPackage() {
    if (!main.currentEm?.emBuyStatus && !main.toBuyPackage[main.currentEm?.id!]) {
      main.toBuyPackage[main.currentEm?.id!] = true;
      if (main.hasAdverties) return false;
      let modalRes = await showConfirm({
        title: '智能检测结果',
        content: '未购买套餐，无法提供联网服务',
        hideCancelBtn: true,
        confirmBtnText: '去订购套餐',
      });
      if (modalRes) {
        // 没有套餐
        navigate('/select-pack');
        return true;
      } else {
        return false;
      }
    }
    return false;
  }
  async function checkRealName() {
    if (
      !realCount.all &&
      !realCount.realNameY &&
      !main.toRealName[main.currentEm?.id!] &&
      !main.toBuyPackage[main.currentEm?.id!]
    ) {
      main.toRealName[main.currentEm?.id!] = true;
      let modalRes = await showConfirm({
        title: '智能检测结果',
        content: '设备下有未实名认证卡片，无法提供联网服务',
        hideCancelBtn: true,
        confirmBtnText: '去实名认证',
      });
      if (modalRes) {
        navigate('/real-name');
        return true;
      }
    }
    return false;
  }

  // 通过设备ID检查是否参与过活动 参与过的不再跳转
  async function checkFirstActivity(id: string) {
    try {
      let res = await apiIsActive(id, RechargeType.first);
      setHasChargeFirstActive(!!res.data.data);
    } catch (e) { }
    setLoaded(true);
  }
  /// 通过设备ID获取活动信息 是否强制参与活动，优先以checkFirstActivity是否参与过活动判断
  async function loadActivity(id: string) {
    try {
      let res = await apiGetFirstActivityList(id);
      let data = res.data;
      if (data.code === 200) {
        let _data = data.data;
        setForceActivity(_data.forceActivity === 'Y');
        setShowActivity(_data.showActivity === 'Y');
      } else {
        showToast(data.msg ?? '获取活动失败,请重试');
      }
    } catch (e: any) {
      showToast(e.message ?? '获取活动失败,请重试');
    }
  }
  async function getShopConfiguration(emNumber: string) {
    let res = await apiGetSysDeptUrl(emNumber);
    setShopConfiguration(res?.data?.data);
    // 获取自定义客服地址
    let res1 = await apiGettKfInfo(emNumber);
    setKfInfo(res1?.data?.data);
  }
  /**
   * 获取首页按钮排序配置
   * 优先级：部门级别 > 套餐级别 > 默认
   */
  async function loadEntrySort(deptId: string, packId: string) {
    try {
      let res = await apiGetClientEntrySortByDept(deptId);
      let data = res?.data?.data;
      if (data && data.length > 0) {
        setEntrySortList(data);
        setEntrySortLoaded(true);
        return;
      }
    } catch (e: any) {}
    try {
      let res = await apiGetClientEntrySortByPack(packId);
      let data = res?.data?.data;
      if (data && data.length > 0) {
        setEntrySortList(data);
        setEntrySortLoaded(true);
        return;
      }
    } catch (e: any) {}
    setEntrySortList(null);
    setEntrySortLoaded(true);
  }
  async function loadCurrentEM() {
    try {
      let emData = main.currentEm;
      if (!emData) {
        let res = await apiGeEmInfo();
        let data = res.data;
        emData = data.data;
      }
      if (emData) {
        setCurrentEm(emData);
        main.currentEm = emData;
        // 优先查询按钮排序配置
        await loadEntrySort(emData?.deptId || '', (emData as any)?.cardProductVo?.packId || '');
        // await loadPayOrderCount(main.currentEm?.id!);
        // await loadPackOrderCount(main.currentEm?.id!);
        // await loadIncomeCount(main.currentEm?.id!);
        // await loadCouponCount(main.currentEm?.id!);
        // 获取当前按钮文案
        await getPackTextDom(main.currentEm);
        await loadRealCount(main.currentEm?.id!);
        await loadActivity(main.currentEm?.id!);
        await loadServerPhone(main.currentEm?.emNumber);
        await loadDianxinTagToRealName(main.currentEm?.emNumber);
        // 始终保持最后一个 保证 loaded
        await checkFirstActivity(main.currentEm?.id!);
        // 获取二次认证入口
        await getCardEmSecondAuth(main.currentEm?.emNumber!);
        // 获取首页广告
        await getProductAdvertiseList(main.currentEm?.id!);
        //获取轮播图
        await getOceanList(main.currentEm?.id!);
        await getHomtTopAdv(main.currentEm?.emNumber!);
        await getShopConfiguration(emData?.emNumber!);
      } else {
        // 没有卡，跳转到切换设备页面
        navigate('/em-list', { state: { backToOut: true } });
      }
    } catch (e: any) {
      // TODO: 网络错误
    }
  }
  /**
   * 首页-顶部广告
   */
  async function getHomtTopAdv(emNumber: string) {
    try {
      let res = await apiGetHomtTopAdv(emNumber);
      let data = res.data;
      if (data.code === 200) {
        let _data = data?.data;
        setHomeTopAdv(_data);
      }
    } catch (e) { }
  }

  async function getCardEmSecondAuth(emNumber: string) {
    LoadingMask.show('加载中...');
    try {
      let res = await apiCardEmSecondAuth(emNumber);
      let data = res.data;
      if (data.code === 200) {
        let _data = data?.data;
        setCardEmSecondAuth(_data);
        if (main.currentEm?.needYdOfficialSecondAuth === '1' && _data?.authStatus === 'N') {
          cardEmSecondAuthDialog(_data);
        }
      }
    } catch (e: any) {
    } finally {
      LoadingMask.hide();
    }
  }
  async function getProductAdvertiseList(id: string) {
    if (!id) return;
    if (!!main.nextBindEm) {
      return;
    }
    try {
      let res = await apiGetProductAdvertiseList({ emId: id, type: CardProductAdvertiseType.Recommend });
      let data = res.data;
      if (data.code === 200) {
        let _data = data?.data ?? [];
        if (_data.length > 0) {
          main.hasAdverties = true;
          let list = _data.map((item: any) => item.cardProductAdvertise);
          setProductAdvertiseList(list);
        }
      } else {
      }
    } catch (e: any) { }
  }

  async function cardEmSecondAuthDialog(_data: CardEmSecondAuth) {
    let modalRes = await showConfirm({
      title: '二次认证',
      content: '接运营商通知，当前网卡需要完成二次认证后才可正常使用，是否前往认证？',
      cancelBtnText: '取消',
      confirmBtnText: '去认证',
    });
    if (!modalRes) return;
    let url =
      _data?.authStatus === 'Y'
        ? '/second-realname'
        : !!_data?.ydH5AuthUrl
          ? _data?.ydH5AuthUrl
          : '/certified-equipment';
    if (!!_data?.ydH5AuthUrl) {
      window.location.href = url;
    } else {
      navigate(url);
    }
  }
  /**
   * 检测打了 电信实名 标签 且未实名的 需要弹窗提示实名 在广告弹窗之后
   * 等广告弹窗关闭后再弹出本弹窗
   * @param emNumber
   * @returns
   */
  async function loadDianxinTagToRealName(emNumber?: string) {
    if (!emNumber) return;
    try {
      let res = await apiGetDianxinTagToRealName(emNumber);
      let data = res.data;
      if (data.code === 200) {
        setDianxinTagWillShow({
          iccid: data.data.iccid,
          show: false,
          need: data.data.showDxRealName,
          realUrl: data.data.realNameLink,
        });
      }
    } catch (e: any) { }
  }
  window.addEventListener(
    'message',
    function (e) {
      // 只处理高度消息
      if (e.data.type === 'iframeHeight') {
        let iframe = document.getElementById('myIframe');
        if (iframe) {
          iframe.style.height = e.data.height + 'px';
        }
      }
      if (e.data.type === 'click') {
        window.location.href = `https://h5.100861.net/product` + e?.data?.data || '';
      }
    },
    false,
  );
  /**
   * 获取服务端配置的客服链接 不同代理可能会有不同的客服链接
   * @param emNumber
   * @returns
   */
  async function loadServerPhone(emNumber?: string) {
    if (!emNumber) return;
    try {
      let res = await apiGetCardLibraryCustomer(emNumber!);
      let data = res.data;
      if (data.code === 200) {
        let _phone = (data.data ?? []).find((i: any) => !!i.serverPhone)?.serverPhone;
        if (!!_phone) {
          setServerPhone(_phone);
        }
      }
    } catch (e: any) { }
  }

  async function loadRealCount(emId: string) {
    try {
      let res = await apiGetRealCount(emId);
      let data = res.data;
      if (data.code === 200) {
        setRealCount(data.data);
      }
    } catch (e: any) { }
  }
  // async function loadPayOrderCount(emId: string) {
  //   try {
  //     let res = await apiGetPayOrderCount(emId);
  //     let data = res.data;
  //     if (data.code === 200) {
  //       setPayOrderCount(data.data);
  //     }
  //   } catch (e: any) { }
  // }

  // async function loadIncomeCount(emId: string) {
  //   try {
  //     let res = await apiGetIncomeCount(emId);
  //     let data = res.data;
  //     if (data.code === 200) {
  //       setIncomeCount(data.data ?? 0);
  //     }
  //   } catch (e: any) { }
  // }

  // async function loadPackOrderCount(emId: string) {
  //   try {
  //     let res = await apiGetPackOrderCount(emId);
  //     let data = res.data;
  //     if (data.code === 200) {
  //       setPackOrderCount(data.data ?? 0);
  //     } else {
  //     }
  //   } catch (e) { }
  // }

  // async function loadCouponCount(emId: string) {
  //   try {
  //     let res = await apiGetCouponCount(emId);
  //     let data = res.data;
  //     if (data.code === 200) {
  //       setCouponCount(data.data ?? 0);
  //     } else {
  //     }
  //   } catch (e) { }
  // }

  /**
   * 取值优先级：
   * 1. 系统参数配置的电话
   * 2. config.js配置的电话
   */
  function handleCallPhone() {
    /**
     * 取值优先级：
     * 0. 卡库
     * 1. 系统参数配置的电话
     * 2. config.js配置的电话
     */
    let tel400 = serverPhone;
    if (!tel400 && main.configList) {
      let config = main.configList.find((i) => i.configKey === main.tel400Key);
      if (config) {
        tel400 = config.configValue!;
      }
    }
    if (!tel400) {
      tel400 = main.tel400;
    }
    window.open(`tel:${tel400}`);
  }

  // 通过广告弹窗跳转套餐购买
  async function handleToBuyEmPack(item?: CardProductAdvertisePackDetailReturnItemJson) {
    setShowRecommendAdvDialog(undefined);
    if (!item?.packDetailId) return;
    try {
      let res = await apiGetCardPackDetail(item.packDetailId);
      let data = res.data;
      if (data.code === 200) {
        let packDetail = data.data;
        navigate('/pack-order-confirm', {
          state: { emPack: packDetail, dateType: 'now' },
        });
      }
    } catch (e) { }
  }
  // 通过广告弹窗跳转页面
  async function handleRedirectPage(item?: CardProductAdvertisePackDetailReturnItemJson) {
    if (item?.linkType === CardProductAdvertiseLinkType.Package) {
      handleToBuyEmPack(item);
    } else if (item?.linkType === CardProductAdvertiseLinkType.Link) {
      if (!!item?.linkUrl) {
        window.location.href = item?.linkUrl;
      }
    }
  }
  async function toPackView() {
    if (realPackPriorityType === RealPackPriorityStatus.real) {
      navigate('/real-name');
    } else {
      navigate('/select-pack');
    }
  }
  async function getRealPackPriorityStatus(currentEm?: CurrentEm) {
    let text = '';
    if (currentEm?.cardProductVo?.realPackPriority === 'pack') {
      if (!currentEm?.emBuyStatus) {
        // 未订购套餐
        text = RealPackPriorityStatus.pack;
      } else if (currentEm?.emBuyStatus && !currentEm?.emRealStatus) {
        // 未实名
        text = RealPackPriorityStatus.real;
      } else {
        text = '';
      }
    } else {
      // 实名优先
      if (!currentEm?.emRealStatus) {
        // 未实名
        text = RealPackPriorityStatus.real;
      } else if (!currentEm?.emBuyStatus && currentEm?.emRealStatus) {
        // 未订购套餐
        text = RealPackPriorityStatus.pack;
      } else {
        text = '';
      }
    }
    return text;
  }
  async function getPackTextDom(currentEm?: CurrentEm) {
    let type = '';
    let _text = await getRealPackPriorityStatus(currentEm);
    if (!!_text) {
      type = _text;
    } else {
      type = RealPackPriorityStatus.pack;
    }
    if (!!type) setRealPackPriorityType(type);
  }

  function handleToComplaint() {
    navigate('/complaint-index');
  }
  // 智能检测
  // eslint-disable-next-line
  async function handleInspect() {
    LoadingMask.show('正在检测...');
    try {
      let res = await apiInspect(currentEm?.id!);
      let data = res.data;
      LoadingMask.hide();
      if (data.code === 200) {
        let inspect: EmInspect = data.data;
        if (!!inspect.packOrder) {
          let modalRes = await showConfirm({
            title: '智能检测结果',
            content: '未购买套餐，无法提供联网服务',
            hideCancelBtn: true,
            confirmBtnText: '去订购套餐',
          });
          if (!modalRes) return;
          navigate('/select-pack');
        } else if (!!inspect.real) {
          let modalRes = await showConfirm({
            title: '智能检测结果',
            content: '设备下无实名认证卡片，无法提供联网服务',
            hideCancelBtn: true,
            confirmBtnText: '去实名认证',
          });
          if (!modalRes) return;
          navigate('/real-name');
        } else if (!!inspect.error) {
          let modalRes = await showConfirm({
            title: '智能检测结果',
            content: '当前设备卡片异常，建议切换网络或者联系客服处理，感谢您的支持和理解！',
            cancelBtnText: '联系客服',
            confirmBtnText: '切换网络',
          });
          if (!modalRes) {
            navigate('/customer');
          } else {
            navigate('/switch-network');
          }
        } else if (!!inspect.flow) {
          let modalRes = await showConfirm({
            title: '智能检测结果',
            content: '当前套餐流量已用尽，可购买套餐后使用联网服务！',
            hideCancelBtn: true,
            confirmBtnText: '去订购套餐',
          });
          if (!modalRes) return;
          navigate('/select-pack');
        } else {
          let modalRes = await showConfirm({
            title: '智能检测结果',
            content: '设备正常，若依然无法联网，请联系客服！',
            cancelBtnText: '关闭',
            confirmBtnText: '联系客服',
          });
          if (!modalRes) return;
          navigate('/customer');
        }
      } else {
        showToast(data.msg ?? '检测失败');
      }
    } catch (e: any) {
      showToast(e.message ?? '检测失败');
    } finally {
      LoadingMask.hide();
    }
  }
  // 菜单-实名认证
  async function handleSelectReal() {
    if (!currentEm?.packDetailName) {
      let modalRes = await showConfirm({
        title: '提示',
        content: '请先订购套餐后，再进行实名认证！',
        cancelBtnText: '关闭',
        confirmBtnText: '前往订购套餐',
      });
      if (modalRes) {
        navigate('/select-pack');
      }
      return;
    }
    navigate('/real-name');
  }

  // 复购 入口配置
  let reBuyEntery: Config | undefined;
  if (main.configList) {
    reBuyEntery = main.configList.find((i) => i.configKey === main.reBuyEnteryKey);
    if (!reBuyEntery?.configValue || !reBuyEntery?.remark) {
      // 没有设置图片或跳转连接就不显示
      reBuyEntery = undefined;
    }
  }

  // // 实名情况 1 全实名 2 部分实名 3 未实名
  // let realNameTag = '1';
  // if (realCount.all) {
  //   realNameTag = '1'
  // } else if (!!realCount.realNameY) {
  //   realNameTag = '2'
  // } else {
  //   realNameTag = '3'
  // }
  //--------------------------------------
  let surplusFlow = flowKTOG(currentEm?.surplusFlow);
  //------------------------------------------

  // 是否显示不限量
  var isUnlimit = flowKTOG(currentEm?.totalFlow ?? 0) >= main.showUnlimited;
  // 运营商

  const settings = {
    dots: false,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // 自动滚动
    autoplaySpeed: 5000, // 每3秒滚动一次
  };

  type OptionItem = { label: string; url: string; img: string; callBack?: () => void; isBacklinks?: boolean; visibility?: string };

  /**
   * 按钮 key -> 行为配置映射
   * 后端只返回 key 和 label，前端根据 key 匹配 img/url/callback/visibility
   * defaultLabel 为后端无配置时的兜底文案
   */
  const BUTTON_MAP: Record<string, Omit<OptionItem, 'label'> & { defaultLabel: string }> = {
    complaint: {
      defaultLabel: '官方投诉',
      url: '/complaint-index',
      img: '/pic/icon_complaint_menu.png',
    },
    exclusive_service: {
      defaultLabel: '专属客服',
      url: '',
      img: '/pic/Customer.png',
      callBack: () => {
        if (kfInfo?.urlContract) {
          let hrefUrl = '';
          if (kfInfo?.urlType === 'link') {
            hrefUrl = kfInfo?.urlContract;
          } else if (kfInfo?.urlType === 'image') {
            hrefUrl = `https://dlc.10086iot.net/feeConfig?url=${encodeURIComponent(kfInfo?.urlContract)}&en=${currentEm?.emNumber}}`;
          }
          window.location.href = hrefUrl;
        } else {
          showToast('没有配置专属客服');
        }
      },
    },
    order_pack: {
      defaultLabel: '订购套餐',
      url: '/select-pack',
      img: '/pic/orders.png',
    },
    real_name: {
      defaultLabel: '实名认证',
      url: '',
      img: '/pic/Realname.png',
      callBack: handleSelectReal,
      visibility:
        currentEm?.cardDetails?.find((item) => item.emNumber === currentEm?.emNumber)?.cardStatus !== 'unknown'
          ? 'Y'
          : 'N',
    },
    switch_network: {
      defaultLabel: '切换网络',
      url: '/switch-network',
      img: '/pic/Internet.png',
      callBack: () => {
        if (!currentEm?.packDetailName) {
          showConfirm({
            title: '提示',
            content: '请先订购套餐后，再进行访问！',
            cancelBtnText: '关闭',
            confirmBtnText: '前往订购套餐',
          }).then((res) => {
            if (res) {
              navigate('/select-pack');
            }
          });
        } else {
          navigate('/switch-network');
        }
      },
      visibility:
        currentEm?.cardDetails?.find((item) => item.emNumber === currentEm?.emNumber)?.cardStatus !== 'unknown'
          ? 'Y'
          : 'N',
    },
    become_agent: {
      defaultLabel: '成为代理',
      url: 'https://wap.100861.net/invite?userId=1849006555355267074',
      isBacklinks: true,
      img: '/pic/broker.png',
      visibility: currentEm?.showJoinDept,
    },
    income_detail: {
      defaultLabel: '消费明细',
      url: '/income-info',
      img: '/pic/Recording.png',
    },
    coupon_center: {
      defaultLabel: '卡券中心',
      url: '/coupon-list',
      img: '/pic/Coupons.png',
    },
    setting: {
      defaultLabel: '设置',
      url: '/setting',
      img: '/pic/setUp.png',
    },
    second_auth: {
      defaultLabel: '二次认证',
      url:
        cardEmSecondAuth?.authStatus === 'Y'
          ? '/second-realname'
          : !!cardEmSecondAuth?.ydH5AuthUrl
            ? cardEmSecondAuth?.ydH5AuthUrl
            : '/certified-equipment',
      img: '/pic/icon_certification.png',
      isBacklinks: !!cardEmSecondAuth?.ydH5AuthUrl,
      visibility: currentEm?.needYdOfficialSecondAuth === '1' ? 'Y' : 'N',
    },
  };

  // 默认按钮顺序（后端无配置时的兆底）
  const DEFAULT_BUTTON_KEYS = [
    'complaint',
    'exclusive_service',
    'order_pack',
    'real_name',
    'switch_network',
    'become_agent',
    'income_detail',
    'coupon_center',
    'setting',
    'second_auth',
  ];

  // 根据后端配置或默认顺序组装 options
  const options = (() => {
    const keys = entrySortList
      ? entrySortList.sort((a, b) => a.sort - b.sort).map((item) => item.key)
      : DEFAULT_BUTTON_KEYS;
    return keys
      .map((key) => {
        const config = BUTTON_MAP[key];
        if (!config) return null;
        const { defaultLabel, ...rest } = config;
        const label = entrySortList?.find((item) => item.key === key)?.label ?? defaultLabel;
        return { label, ...rest };
      })
      .filter(Boolean) as OptionItem[];
  })();

  const [shoppingCentr_data, setShoppingCentr_data] = useState<any[]>([]);

  async function getShopData(id: string | number) {
    try {
      if (id === 'tuijian') {
        const res = await apiGetMainlyPromoteGoods();
        if (res.status === 200) {
          setShoppingCentr_data(res.data?.data || []);
        }
      } else if (id) {
        const res = await apiGettGoodsList(id);
        if (res.status === 200) {
          setShoppingCentr_data(res.data?.data || []);
        }
      }
    } catch (e: any) { }
  }

  function renderDom() {
    return (
      <div className="bw-100 img-box">
        {currentEm?.marketingStatus !== 'N' && oceanList?.left.length > 0 && (
          <div className="mt-10 inline-block img-show" style={oceanList?.right?.length > 0 ? {} : { width: '50%' }}>
            <Slider {...settings} infinite={oceanList?.left.length <= 1 ? false : true} className="bw-100 slider-box">
              {oceanList?.left?.map((item, index) => {
                return (
                  <div key={index}>
                    <img
                      className="bw-100"
                      src={item?.imgUrl}
                      alt=""
                      // onClick={() => {
                      //   window.location.href = `https://dlc.10086iot.net/fsl?did=${currentEm?.deptId}`;
                      // }}
                      onClick={() => {
                        if (item?.type === 'contact') {
                          window.location.href = `https://dlc.10086iot.net/fsl?did=${currentEm?.deptId}`;
                        } else if (item?.type === 'no' || !item?.skipUrl) {
                          return false;
                        } else if (item?.type === 'in') {
                          navigate(item.skipUrl);
                        } else if (item?.type === 'out') {
                          window.location.href = item.skipUrl;
                        }
                      }}
                    />
                  </div>
                );
              })}
            </Slider>
          </div>
        )}

        {currentEm?.showPurchaseEntry === 'Y' && oceanList?.right.length > 0 && (
          <div className="mt-10 inline-block img-show" style={oceanList?.left?.length > 0 ? {} : { width: '50%' }}>
            <Slider {...settings} infinite={oceanList?.right.length <= 1 ? false : true} className="bw-100 slider-box">
              {oceanList?.right?.map((item, index) => {
                return (
                  <div key={index}>
                    <img
                      className="bw-100"
                      src={item?.imgUrl}
                      alt=""
                      onClick={() => {
                        if (item?.type === 'no' || !item?.skipUrl) {
                          return false;
                        } else if (item?.type === 'in') {
                          navigate(item.skipUrl);
                        } else if (item?.type === 'out') {
                          window.location.href = item.skipUrl;
                        }
                      }}
                    />
                  </div>
                );
              })}
            </Slider>
          </div>
        )}
      </div>
    );
  }
  return (
    <Page className="d-flex-c bg-gray home-page" contentClassName="d-flex-c flex-1 h-1 pos-r">
      <img className="bw-100 pos-a" src="/pic/pic_page_bg.png" alt="" />

      <div className="pos-a l-0 r-0 t-0 b-0 pl-20 pr-20 pt-20 pb-60 overflow-y">
        {!!homeTopAdv?.topImg && homeTopAdv?.topImgStatus === 'Y' && (
          <img
            style={{ margin: '-10px -10px 10px' }}
            className="w-355 border-radius-10"
            src={homeTopAdv?.topImg}
            alt=""
            onClick={() => {
              if (
                homeTopAdv?.topImgStatus === 'Y' &&
                !!homeTopAdv?.topImgUrl &&
                homeTopAdv?.topImgUrl.startsWith('http')
              ) {
                window.location.href = homeTopAdv?.topImgUrl;
              }
            }}
          />
        )}
        <div className="d-flex-r ai-center">
          <div className={`w-8 h-8 border-radius-harf mr-10 `} />
          <span className="font-size-12">设备号:{currentEm?.emNumber}</span>
          <img
            className="icon-12 ml-10"
            src="/pic/icon_action_copy.png"
            alt=""
            onClick={() =>
              copyToClipboard(currentEm?.emNumber!, () => {
                showToast('复制成功');
              })
            }
          />
          <div className="flex-1"></div>
          <div className="d-flex-r ai-center" onClick={() => navigate('/em-list')}>
            <img className="icon-12 mr-10" src="/pic/icon_swap.png" alt="" />
            <div className="text-color-p">切换设备</div>
          </div>
        </div>
        <div className="d-flex-r ai-center">
          <div className={`w-8 h-8 border-radius-harf mr-10 ${currentEm?.emRealStatus ? 'bg-green' : 'bg-red'}`} />
          <span
            className="font-size-12"
            onClick={() => {
              if (currentEm?.emRealStatus) return;
              handleSelectReal();
            }}
          >
            实名状态:{currentEm?.emRealStatus ? '已实名' : '未实名'}
          </span>
        </div>
        <div className="mt-20 d-flex-r">
          <div className="flex-1 h-100" style={{ padding: 10 }}>
            <div className="d-flex-r ai-start font-widget-600">
              <div className="font-size-48 ">
                {isUnlimit ? '不限量' : surplusFlow <= 0 ? 0 : formatNumber(surplusFlow)}
              </div>
              {!isUnlimit && <div className="font-size-16 mt-5">G</div>}
            </div>
            <div className="font-size-12">本期剩余流量</div>
          </div>
          <div className="flex-1 h-100 d-flex-c pb-30 pl-30 ai-center jc-center" style={{ padding: 10 }}>
            <Button className="btn-shadow" type="primary" size="lg" shape="circle" onClick={toPackView}>
              <div className="w-100">{RealPackPriorityStatus.getStatusStr(realPackPriorityType)}</div>
            </Button>
          </div>
        </div>
        <div className="package-info bg-white border-radius-10">
          <div className=" package-info-l mt-10 mb-10">
            <div className="text-color-9 flex-1 text-center">当前套餐</div>
            <div className="font-widget-600 mt-5 font-size-16 text-center word-break">
              <NoticeBar
                text={currentEm?.packDetailName ?? '--'}
                speed={50}
                color={'#000'}
                className="NoticeBar"
                background="#fff"
              />
            </div>
            <div className="font-size-12 text-color-9 mt-5 text-center word-break">
              有效期：{currentEm?.lastEndEffectTime ? dayjs(currentEm?.lastEndEffectTime).format('YYYY-MM-DD') : '--'}
            </div>
            {/* <img className="pos-a r-10 b-30 icon-40" src="/pic/icon_curr_pack.png" alt="" /> */}
          </div>
          {/* <div className="pt-10"></div> */}
          <div className="  package-info-c mt-10 mb-10">
            <div className="text-color-9 flex-1 text-center">已用流量</div>
            <div className=" ai-end mt-5 text-center text">
              <span className="font-widget-600 font-size-22">{formatNumber(flowKTOG(currentEm?.usedFlow))}</span>
              <span className="font-size-12 font-widget-600 ml-5 mt-2">GB</span>
            </div>
            {/* <img className="r-10 b-10 pos-a icon-40" src="/pic/icon_flow.png" alt="" /> */}
          </div>
          <div
            className="package-info-r pt-10 pb-10 "
            onClick={() => {
              currentEm?.cardProductVo?.showBalanceStatus === 'show' && navigate('/recharge');
            }}
          >
            <div className="text-color-9 flex-1 text-center">账户金额</div>
            <div className="flex-1 text-center">
              <div className="flex-1  ai-end bw-100 text-center">
                <span className="font-size-22 font-widget-600">
                  {/* {formatNumber(currentEm?.cardDetailWalletVo?.availableAmount)} */}
                  {formatNumber(
                    Number(currentEm?.cardDetailWalletVo?.availableAmount ?? 0) +
                    Number(currentEm?.cardDetailWalletVo?.activityAmount ?? 0),
                  )}
                </span>
                <span className="font-size-12 ml-5 mb-3">元</span>
              </div>
              {/* || currentEm?.showPayBtn === 'Y' */}
              {(currentEm?.cardProductVo?.showBalanceStatus === 'show') && (
                <div className=" text-color-p text-underline">去充值</div>
              )}
            </div>
          </div>
        </div>
        {currentEm?.marketingStatus === 'Y' && currentEm?.showPurchaseEntry === 'Y' && renderDom()}
        {!!currentEm?.equipmentLogVo && <WifiInfo emId={currentEm?.id!} info={currentEm?.equipmentLogVo} />}

        {entrySortLoaded && (
          <div className="d-flex-r mt-10">
            <div className="options-info bg-white border-radius-10">
              <ul>
                {options.map((item, index) => (
                  <li
                    key={index}
                    style={item.visibility === 'N' ? { display: 'none' } : {}}
                    onClick={async () => {
                      if (item.isBacklinks) {
                        window.location.href = item.url;
                      } else if (item.callBack) {
                        item.callBack();
                      } else {
                        navigate(item.url);
                      }
                    }}
                  >
                    <div className="img-box">
                      <img src={item.img} alt="" />
                    </div>
                    <span className="font-size-12">{item.label}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
        {!!currentEm && (currentEm?.marketingStatus !== 'Y' || currentEm?.showPurchaseEntry !== 'Y') && renderDom()}

        {currentEm?.marketingStatus !== 'N' && (
          <div className="d-flex-r mt-10">
            <div className="shoppingCentre-info">
              <div className="shoppingCentre-title bg-white font-size-18 border-radius-10">
                商城
                <span
                  className="font-size-12 mr-10"
                  onClick={(e) => {
                    if (shopConfiguration?.marketingStatus === 'Y' && shopConfiguration?.moGoodsLink) {
                      window.location.href = shopConfiguration?.moGoodsLink;
                    } else {
                      navigate(`/homepage-shop`, {
                        state: {},
                      });
                    }
                  }}
                  style={{ float: 'right' }}
                >{`更多商品>`}</span>
              </div>
              {!shopConfiguration ? null : shopConfiguration?.marketingStatus === 'Y' &&
                shopConfiguration?.goodsLink ? (
                <iframe
                  id="myIframe"
                  style={{ border: 'none' }}
                  src={`${shopConfiguration?.goodsLink}&from=wsl`}
                  width="100%"
                ></iframe>
              ) : (
                <div className="shoppingCentre-data pt-10 mt-5">
                  {shoppingCentr_data.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className="shoppingCentre-data-item mb-8 border-radius-10"
                        onClick={() =>
                          (window.location.href = `https://wap.100861.net/goods?goodsId=${item.id}&form=wsl`)
                        }
                      >
                        <div className="shoppingCentre-data-item-t">
                          <img src={item?.goodsListImg} alt="" />
                        </div>
                        <div className="shoppingCentre-data-item-b">
                          <div className="shoppingCentre-data-item-title pl-5 mt-5">
                            {!!item.goodsTagIcon && (
                              <img
                                className="h-16 mr-5"
                                style={{ verticalAlign: 'middle' }}
                                src={GoodsTagIcon.getTagIcon(item.goodsTagIcon)}
                                alt=""
                              />
                            )}
                            {item.goodsTitle}
                          </div>
                          <div className="shoppingCentre-data-item-people mt-5 pr-5 pl-5 text-color-9 font-size-12">
                            已有{item?.virtualSales || 0}人下单
                          </div>

                          <div className="tags-box mt-5">
                            <div className="tags-box-l font-size-12">
                              {item?.goodsTags?.split(',')?.map((item: any) => {
                                return (
                                  <span
                                    key={item}
                                    className="mr-5 mb-10 tags pv-1 ph-3 border-radius-4 font-size-12 text-color-red bg-color-red-t3"
                                  >
                                    {item}
                                  </span>
                                );
                              })}
                            </div>

                            <div
                              className="shoppingCentre-data-item-share "
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/homepage-detail`, {
                                  state: {
                                    imgUrl: item.goodsDetailImg ?? '',
                                    title: item.goodsTitle ?? '',
                                    inviteUserId: '',
                                    goodsId: item.id,
                                  },
                                });
                              }}
                            >
                              <img src="/pic/icon_export.png" alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        )}
        <div className="text-center text-color-9 p-20 font-size-12">
          <span onClick={handleCallPhone}>服务热线</span>
          <span className="ml-10 mr-10">|</span>
          <span onClick={handleToComplaint}>投诉建议</span>
        </div>
      </div>
      {hasChargeFirstActive && <FirstActiveFloat />}
      {!!showRecommendAdvDialog && <RecommendAdvDialog imgList={showRecommendAdvDialog} onOk={handleToBuyEmPack} />}
      {!!productAdvertiseList && (
        <PopupQueueComponent
          popupList={productAdvertiseList}
          onChange={(v) => {
            handleRedirectPage(v);
          }}
        />
      )}
    </Page>
  );
}
